import classnames from 'classnames';
import * as React from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { Market, RootState, selectCurrentMarket, selectMarketSelectorState } from '../../../modules';
// import searchIcon from '../icons/search.svg';
import { MarketsList } from './MarketsList';
import { MarketsTabs } from './MarketsTabs';
import { fetchTickersGroupRequest } from '../../../modules/public/tickers/actions';
import Search from 'antd/es/transfer/search';

interface ReduxProps {
    currentMarket?: Market;
    isOpen: boolean;
}

interface DispatchProps {
    tickersGroupFetch: typeof fetchTickersGroupRequest;
}

interface State {
    searchFieldValue: string;
    marketsTabsSelectedValue: string;
}

class MarketSelectorComponent extends React.Component<ReduxProps & DispatchProps, State> {
    public readonly state = {
        searchFieldValue: '',
        marketsTabsSelectedValue: '',
    };

    public render() {
        const { isOpen } = this.props;
        const { searchFieldValue, marketsTabsSelectedValue } = this.state;

        const listClassName = classnames({
            'pg-trading-header-selector-list-container-open': isOpen,
            'pg-trading-header-selector-list-container-close': !isOpen,
        });
        const searchSelectorClassName = classnames({
            'pg-trading-header-selector-search': isOpen,
            'pg-trading-header-selector-search-closed': !isOpen,
        });

        return (
            <div className="pg-trading-header-selector-container">
                <div className={listClassName}>
                    <MarketsTabs onSelect={this.marketsTabsSelectHandler} />
                    <div className={searchSelectorClassName}>
                        <Search
                            // className="pg-trading-header-selector-search__input"
                            placeholder="Searching ..."
                            onChange={this.searchFieldChangeHandler}
                        />
                    </div>
                    <MarketsList search={searchFieldValue} currencyQuote={marketsTabsSelectedValue} />
                </div>
            </div>
        );
    }

    private searchFieldChangeHandler = (e: any) => {
        this.setState({
            searchFieldValue: e.target.value,
        });
    };

    private marketsTabsSelectHandler = (value: any) => {
        this.props.tickersGroupFetch(value);
    };
}
const mapDispatchToProps = (dispatch: any) => ({
    tickersGroupFetch: (payload: string) => dispatch(fetchTickersGroupRequest(payload)),
});
const reduxProps: MapStateToProps<ReduxProps, {}, RootState> = (state) => ({
    currentMarket: selectCurrentMarket(state),
    isOpen: selectMarketSelectorState(state),
});

export const MarketSelector = connect(reduxProps, mapDispatchToProps)(MarketSelectorComponent);
